/* global jQuery */

($ => {
  $(() => {
    // $('.js-filter-tr-components').off();
    const targetClass =
      ".wp-block-kehittamo-block-tilaratkaisut-components-filter-target";
    const componentClass = ".wp-block-kehittamo-block-tilaratkaisut-component";

    const filterComponents = ({ items, selectedFilters }) => {
      if (!items.length) {
        return;
      }
      // Show all if no filters selected.
      if (!Object.keys(selectedFilters).length) {
        items.forEach(({ $element }) => {
          $element.slideDown();
        });
        return;
      }

      const filterEntries = Object.entries(selectedFilters);
      items.forEach(({ $element, meta }) => {
        if (
          // At least one from each selected meta's values must hit.
          filterEntries.every(
            ([filterName, filterValues]) =>
              Object.hasOwnProperty.call(meta, filterName) &&
              filterValues.some(filterValue =>
                meta[filterName].includes(filterValue)
              )
          )
        ) {
          $element.slideDown();
        } else {
          $element.slideUp();
        }
      });
    };

    // Build items
    const items = [];
    $(targetClass).each((_, t) => {
      const $target = $(t);
      const meta = {};
      $target.find(`${componentClass} [data-meta-name]`).each((_, el) => {
        const { metaName, metaValue } = $(el).data();
        if (!Object.hasOwnProperty.call(meta, metaName)) {
          meta[metaName] = [];
        }
        meta[metaName].push(metaValue);
      });

      const newItem = {
        $element: $target,
        meta
      };
      items.push(newItem);
    });

    const selectedFilters = {};
    $(".js-filter-tr-components").on("click", "button", function clickFilter() {
      const $this = $(this);
      const { metaName, metaValue } = $this.data();
      if (!Object.hasOwnProperty.call(selectedFilters, metaName)) {
        selectedFilters[metaName] = [];
      }
      if (metaName === "tr_component_type") {
        // We can choose multiple component types for filtering.
        const removeIdx = selectedFilters[metaName].indexOf(metaValue);
        if (removeIdx !== -1) {
          $this.removeClass("is-active");
          selectedFilters[metaName].splice(removeIdx, 1);
          if (!selectedFilters[metaName].length) {
            delete selectedFilters[metaName];
          }
        } else {
          $this.addClass("is-active");
          selectedFilters[metaName].push(metaValue);
        }
      } else {
        // We can only select one SRIS value at a time.
        if (
          Array.isArray(selectedFilters[metaName]) &&
          selectedFilters[metaName].indexOf(metaValue) >= 0
        ) {
          // If the button is already selected, remove the selection.
          $this.removeClass("is-active");
          delete selectedFilters[metaName][metaValue];
        } else {
          // Otherwise empty all selections and add the new selection.
          selectedFilters[metaName] = [];
          const buttons = $(
            ".wp-block-kehittamo-block-tilaratkaisut-components-filter__buttons--sris button"
          );
          buttons.removeClass("is-active");
          selectedFilters[metaName].push(metaValue);
          $this.addClass("is-active");
        }
      }
      filterComponents({ items, selectedFilters });
    });
  });
})(jQuery);
